import { PillStateType } from '@kubit/web-ui-components/pill/types';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../variants';
import { commonStyles, labelDisabledCommonStyles, labelDisabledSelectedCommonStyles, labelSelectedCommonStyles, } from '../commonStyles';
const buildCommonProps = (FOUNDATIONS, FONT) => ({
    ...commonStyles(FOUNDATIONS, FONT),
    labelAndSecondLabelContainer: {
        display: 'flex',
        flex_direction: 'row',
        column_gap: FOUNDATIONS.spacing_50,
        align_items: 'center',
    },
    secondLabel: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_forms_pill_unselected_font,
    },
    showSecondLabel: true,
    showRightIcon: true,
});
export const getDropdownStyles = (FOUNDATIONS, FONT) => {
    const commonProps = buildCommonProps(FOUNDATIONS, FONT);
    return {
        [PillStateType.DEFAULT]: {
            ...commonProps,
            showSecondLabel: false,
        },
        [PillStateType.SELECTED]: {
            ...commonProps,
            label: {
                ...labelSelectedCommonStyles(FOUNDATIONS, FONT),
            },
            secondLabel: {
                ...labelSelectedCommonStyles(FOUNDATIONS, FONT),
            },
        },
        [PillStateType.DISABLED]: {
            ...commonProps,
            label: {
                ...labelDisabledCommonStyles(FOUNDATIONS, FONT),
            },
            secondLabel: {
                ...labelDisabledCommonStyles(FOUNDATIONS, FONT),
            },
        },
        [PillStateType.DISABLED_SELECTED]: {
            ...commonProps,
            label: {
                ...labelDisabledSelectedCommonStyles(FOUNDATIONS, FONT),
            },
            secondLabel: {
                ...labelDisabledSelectedCommonStyles(FOUNDATIONS, FONT),
            },
        },
    };
};
//# sourceMappingURL=dropdown.js.map